import { Controller } from '@hotwired/stimulus'
import Cookies from 'js-cookie'

export default class extends Controller {
  static values = {
    cta: String,
    ctaCount: { type: Number, default: 1 }
  }

  connect() {
    if (this.element.classList.contains('guest-client-banner')) this.displayOnScroll()
    if (this.element.classList.contains('guest-presta-banner')) this.displayAfterDelay()
  }

  displayOnScroll() {
    document.addEventListener('scroll', () => {
      const y = window.scrollY
      let yBottomBanner = 300
      const banner = document.querySelector('.banner')
      if (banner) yBottomBanner += banner.offsetTop + banner.offsetHeight

      y > yBottomBanner ? this.element.classList.add('visible') : this.element.classList.remove('visible')
    })
  }

  displayAfterDelay() {
    setTimeout(() => this.element.classList.add('visible'), 5000)
  }

  close() {
    this.element.classList.remove('visible')
    this.updateCookie()

    setTimeout(() => this.element.remove(), 250)
  }

  updateCookie() {
    const cookieName = this.ctaValue
    const maxCount = this.ctaCountValue

    if (Number.isNaN(maxCount)) {
      Cookies.set(cookieName, true, { expires: 15, path: '/' })
      return
    }

    const currentCount = parseInt(Cookies.get(cookieName), 10)

    if (Number.isNaN(currentCount)) {
      Cookies.set(cookieName, 1, { expires: 15, path: '/' })
    } else if (currentCount + 1 >= maxCount) {
      Cookies.set(cookieName, true, { expires: 15, path: '/' })
    } else {
      Cookies.set(cookieName, currentCount + 1, { expires: 15, path: '/' })
    }
  }
}
